module.exports = __webpack_public_path__ + "vue/img/yidong.bec83f30.png";